import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

console.log("Appen har startat!");

const render = () => ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

if ((window.SPORTS_HQ_SETTINGS_READY || window.SPORTS_HQ_SESSION_READY)) (window.SPORTS_HQ_SETTINGS_READY || window.SPORTS_HQ_SESSION_READY).then(render); else render();
